import { Centered } from './Centered';

export default Centered;
